import { getCountryFullName } from './CountryUtils';

const INVOICING_FORM_BASE_URL = `/invoicing/form`;
const TRACK_INVOICING_BASE_URL = `/invoicing/track`;
// TODO (US migration v2): Remove EU keyword from retention form URLs
const RETENTION_FORM_BASE_URL = `/eu/retention/form`;

export const VIEW_ROUTES_URL = {
    // Older URL supported solely for the EU applications [should be re-directed to the generic ONBOARDING URL]
    EU_ONBOARDING: `/eu/onboarding/:url`,
    ONBOARDING: `/onboarding/:url`,
    TRACK_INVOICING: `${TRACK_INVOICING_BASE_URL}/:url`,
    INVOICING_FORM: `${INVOICING_FORM_BASE_URL}/:url`,
    RETENTION_FORM: `${RETENTION_FORM_BASE_URL}/:url`,
    // Older URLs used for EU/US privacy policy page, which are now re-directed
    EU_PRIVACY_POLICY: `/eu/privacy-policy/latest`,
    US_PRIVACY_POLICY: `/us/privacy-policy/latest`,
    // URL directing the main privacy notice page
    PRIVACY_POLICY: `/privacy-notice/latest`,
};

export const getUrlForTrackInvoicing = (url) =>
    `${TRACK_INVOICING_BASE_URL}/${url}`;

export const getUrlForInvoicingForm = (url) =>
    `${INVOICING_FORM_BASE_URL}/${url}`;

export const getUrlForRetentionForm = (url) =>
    `${RETENTION_FORM_BASE_URL}/${url}`;

export const getPrivacyPolicyPageUrlByCountry = (country) =>
    `${VIEW_ROUTES_URL.PRIVACY_POLICY}?country=${getCountryFullName(country)}`;
